import { render } from "./TdmRes.vue?vue&type=template&id=29c8e96a&scoped=true&ts=true"
import script from "./TdmRes.vue?vue&type=script&lang=ts"
export * from "./TdmRes.vue?vue&type=script&lang=ts"

import "./TdmRes.vue?vue&type=style&index=0&id=29c8e96a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c8e96a"]])

export default __exports__